import type { FaireProductEntity } from "../../entity_types/product";

export const p_ebbamkd6hz: FaireProductEntity = {
  token: "p_ebbamkd6hz",
  type: "product",
  name: "Lace-Up Front Slim Fit Blazer Jacket",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/96d2afa0b56e2af91b6b3ffedc9e4c306d303da8422e773eb4b635da6544d4eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c64d0a73b81c31948c087cc55b76e9df8b8d0ac153c14451e543c839cb0f3db.jpeg",
    "https://cdn.faire.com/fastly/3efdc487a69ed707b6830baca459410f271e1666908e558acf51baf4dceadf57.jpeg",
    "https://cdn.faire.com/fastly/6151002ab2596404ac7f99e72c0e67bb3329cab10c50759f1dbfb71d0538877e.jpeg",
    "https://cdn.faire.com/fastly/42bb5dedf16f07fd31a8c0b368d173b6c34897442b1b5026420e223e5da1c605.jpeg",
    "https://cdn.faire.com/fastly/1757f5ba30808d05c2f7b030b08045c454d9c32dc86d720ef36fae028c0639c4.jpeg",
    "https://cdn.faire.com/fastly/40794af4206112a69ab8dde4f85b5d0dcba7fa152a53858591923635d4e8770f.jpeg",
    "https://cdn.faire.com/fastly/ae3b91e1e830326b7237b0eefb63d625d30f6b532c3dcd965b5d0a1c06672a99.jpeg",
    "https://cdn.faire.com/fastly/c1822b7bcc97ed3158609308321d75de0cacfecaed5247a4c05dddcf6794d1f5.jpeg",
    "https://cdn.faire.com/fastly/fd1971c654df8cdd78adebbe6fa40f25b27dc4fbe688d4cb7fb5284c24f8bf8e.jpeg",
    "https://cdn.faire.com/fastly/2dc5f4fe0d4b74a4bafe769f7e5f8ee9fdbb713cb2b487f7f95505ddd6c1346d.png",
  ],
  priceDollars: 41.65,
  description:
    "ELEVATE YOUR MODERN TAILORED STYLE WITH THIS SLEEK LACE-UP FRONT BLAZER, FEATURING A SLIM-FIT SILHOUETTE AND CONTEMPORARY DESIGN FOR SOPHISTICATED WEAR.\n\nIMPORTED, DESIGNED IN USA\n\nCONTEMPORARY LACE-UP FRONT DETAIL\n\nTAILORED SLIM FIT AND STRUCTURED COLLAR\n\nCONT 100% POLYESTER\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:21.877Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
